import { IErknmAnalyticsTableColumn } from '../interfaces/IErknmAnalyticsTableColumn';

export const initialErknmAnalyticsTableColumns: IErknmAnalyticsTableColumn[] = [
  {
    id: 'name',
    name: '',
  },
];
